module.exports = "//public.zight.com/packs/media/images/view-grid-ead5d27d9d6881d1cb31fb9cecf0b9c5.svg";